module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n      Case Manager\n    ")])], 1), _vm._v(" "), _c('v-list', [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), (_vm.managerData) ? _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.toggleChangeCaseManager) ? _c('v-select', {
    attrs: {
      "items": _vm.users,
      "label": "Select new manager",
      "disabled": _vm.disabled.caseManagerSelect || _vm.closed
    },
    model: {
      value: (_vm.selectedCaseManager),
      callback: function($$v) {
        _vm.selectedCaseManager = $$v
      },
      expression: "selectedCaseManager"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.toggleChangeCaseManager) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.managerData.name) + "\n          "), (!_vm.closed) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": "",
      "color": "teal"
    },
    on: {
      "click": function($event) {
        _vm.toggleChangeCaseManager = true
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Email")])])]), _vm._v(" "), (_vm.managerData) ? _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.managerData.email || 'N/A') + "\n      ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2111dd9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseUserCreatedDataTable.vue
// module id = 968
// module chunks = 1